import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { OrganizerModel } from '../../types';
import { themeConfig } from '../../styles/themeConfig';
import { BText } from '../BText';

type props = {
  organizer: OrganizerModel;
  onClose: Function;
};

export const OrganizerContacts = ({ organizer, onClose }: props) => {
  const [email, setEmail] = useState<string | null>(null);
  const [phone, setPhone] = useState<string | null>(null);

  useEffect(() => {
    const emailEntry = organizer.contactInfo.find(c => c.contactType === 'email');
    const phoneEntry = organizer.contactInfo.find(c => c.contactType === 'phone');

    if (emailEntry) {
      setEmail(emailEntry.contact);
    }

    if (phoneEntry) {
      setPhone(phoneEntry.contact);
    }
  }, []);

  const organizerAction = (action: string) => {
    switch (action) {
      case 'email':
        window.open(`mailto:${email}`);
        break;
      case 'wa':
        window.open(`https://api.whatsapp.com/send?phone=${phone}`);
        break;
      case 'sms':
        window.open(`sms:${phone}`);
        break;
      case 'call':
        window.open(`tel:${phone}`);
        break;
    }

    onClose(false);
  };

  return (
    <View style={styles.container}>
      {email && (
        <Pressable onPress={() => organizerAction('email')}>
          <BText style={styles.item} ellipsizeMode="tail" numberOfLines={1}>
            Send email to {email}
          </BText>
        </Pressable>
      )}
      {phone && (
        <>
          <Pressable onPress={() => organizerAction('wa')}>
            <BText style={styles.item} ellipsizeMode="tail" numberOfLines={1}>
              Send WhatsApp to {phone}
            </BText>
          </Pressable>
          <Pressable onPress={() => organizerAction('sms')}>
            <BText style={styles.item} ellipsizeMode="tail" numberOfLines={1}>
              Send SMS to {phone}
            </BText>
          </Pressable>
          <Pressable onPress={() => organizerAction('call')}>
            <BText style={styles.item} ellipsizeMode="tail" numberOfLines={1}>
              Call {phone}
            </BText>
          </Pressable>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  item: {
    fontSize: 20,
    color: themeConfig.colors.link,
    textAlign: 'center',
    paddingVertical: 12,
    width: '100%',
    ellipsizeMode: 'tail',
    borderTopWidth: 1,
    borderTopColor: themeConfig.colors.lightGrey,
  },
});
